module.exports = __webpack_public_path__ + "static/turtle-creek-house14-a119289b112411bb0d41ef7526754693.jpg";